import React from 'react'

import { Button, FormattedHTMLMessage } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import s from './s.module.css'
import { lang } from './lang'
import { globalLang } from '~globalLang'

interface Props {
    onClose?: () => void
}

// eslint-disable-next-line max-lines-per-function
function Email({ onClose }: Props) {
    const intl = useIntl()
    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <div className={s.wrap}>
            <FormattedHTMLMessage {...lang.title} className={s.title} />
            <div className={s.content}>
                <FormattedHTMLMessage {...lang.description} className={s.description} />
            </div>
            <div className={s.button}>
                <Button dataPointer="contact" size="l" href={supportLink} role="anchor" fullWidth>
                    <FormattedHTMLMessage {...lang.contact} />
                </Button>
                <Button dataPointer="cancel" size="l" mode="primary" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.close} />
                </Button>
            </div>
        </div>
    )
}

export default Email
